/* eslint-disable @next/next/no-img-element */
import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { Layout, Seo, SubscribeForm, VideoLightbox } from '@/components/generals'
import { routes } from '@/lib/routes'

const HomePage: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Home'
                description='San Diego keeps your time, expenses, and tasks on-brand, on message, and on time. Effortless living made possible.'
            />

            <div className='section-hero'>
                <div className='main-hero-container'>
                    <div className='small-container'>
                        <div className='text-center'>
                            <div className='hero-link-holder'>
                                <div className='text-hidden'>
                                    <div className='hero-top-content'>
                                        <Link href={routes.features} className='hero-link w-inline-block'>
                                            <div className='link-new-badge'>New</div>
                                            <div>Introducing the Class app</div>
                                            <div className='hero-link-arrow' />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <h1 className='main-heading'>
                                Unleash the Power of <span className='text-gradient'>Seamless</span> Living
                            </h1>
                            <div className='w-layout-grid grid-10-columns'>
                                <p id='w-node-_72db7d5e-67ba-1361-b1aa-1a07ac8f1178-6c33c78d' className='hero-description'>
                                    San Diego keeps your team&apos;s work on-brand, on message, and on time. Innovative features
                                    make creating and sharing your work feel effortless.
                                </p>
                            </div>
                            <div className='download-buttons hero-download-buttons'>
                                <div className='download-button'>
                                    <a href='https://apple.com' target='_blank' rel='noreferrer' className='button black-button w-inline-block'>
                                        <img src='/images/Apple-Icon.svg' loading='lazy' alt='' className='download-button-icon' />
                                        <div>
                                            <span className='hide-on-mobile'>Download for </span>iOS
                                        </div>
                                    </a>
                                </div>
                                <div className='download-button'>
                                    <a href='https://play.google.com/store/apps' target='_blank' rel='noreferrer' className='button black-button w-inline-block'>
                                        <img src='/images/Android-Icon.svg' loading='lazy' alt='' className='download-button-icon' />
                                        <div>
                                            <span className='hide-on-mobile'>Download for </span>Android
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='home-hero-container'>
                    <div className='hero-text-sticky'>
                        <div className='hero-text-holder'>
                            <div className='hero-text-holder-1'>
                                <h1 className='hero-text _1'>Meet</h1>
                                <div className='hero-text-white-gradient white-gradient-on-right' />
                            </div>
                            <div className='hero-text-line' />
                            <div className='hero-text-holder-2'>
                                <div className='hero-text-white-gradient' />
                                <h1 className='hero-text _2'>Class</h1>
                            </div>
                        </div>
                    </div>
                    <div className='hero-product-demo'>
                        <div className='product-demo-sticky'>
                            <div className='product-phone-image-container'>
                                <div className='product-container'>
                                    <div className='product-phone-image-holder'>
                                        <img
                                            src='/images/Holding-iPhone.webp'
                                            loading='lazy'
                                            sizes='(max-width: 1279px) 100vw, 1313.5px'
                                            srcSet='/images/Holding-iPhone-p-500.png 500w, /images/Holding-iPhone-p-800.png 800w, /images/Holding-iPhone-p-1080.png 1080w, /images/Holding-iPhone-p-1600.png 1600w, /images/Holding-iPhone-p-2000.png 2000w, /images/Holding-iPhone.webp 2475w'
                                            alt='San Diego app on iPhone'
                                            className='product-phone-image'
                                        />
                                        <div className='product-phone-content'>
                                            <img src='/images/SD-App.svg' loading='lazy' alt='' className='product-phone-demo-image _1' />
                                            <img
                                                src='/images/App2.webp'
                                                loading='lazy'
                                                sizes='(max-width: 479px) 100vw, 554px'
                                                srcSet='/images/App2-p-500.jpg 500w, /images/App2-p-800.jpg 800w, /images/App2.webp 1020w'
                                                alt=''
                                                className='product-phone-demo-image _2'
                                            />
                                            <img
                                                src='/images/LockScreen.webp'
                                                loading='lazy'
                                                sizes='(max-width: 479px) 100vw, 554px'
                                                srcSet='/images/LockScreen-p-500.jpg 500w, /images/LockScreen-p-800.jpg 800w, /images/LockScreen.webp 1020w'
                                                alt=''
                                                className='iphone-lock-screen-image'
                                            />
                                        </div>
                                    </div>
                                    <VideoLightbox videoId='sWRUzxINCoA' className='play-icon-holder w-inline-block'>
                                        <img src='/images/play-button.svg' loading='lazy' alt='Play video' className='play-icon-image' />
                                    </VideoLightbox>
                                </div>
                                <div className='hero-gradient-holder'>
                                    <div className='hero-gradient-box'>
                                        <div className='play-me-holder'>
                                            <div className='play-me-holder-text _1'>
                                                <div className='play-me-text'>Play Me</div>
                                                <div className='play-me-text'>Play Me</div>
                                                <div className='play-me-text'>Play Me</div>
                                                <div className='play-me-text'>Play Me</div>
                                            </div>
                                            <div className='play-me-holder-text _2'>
                                                <div className='play-me-text'>Play Me</div>
                                                <div className='play-me-text'>Play Me</div>
                                                <div className='play-me-text'>Play Me</div>
                                                <div className='play-me-text'>Play Me</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section second'>
                <div className='big-text-white-gradient-holder top-big-text-gradient-holder'>
                    <div className='big-text-white-gradient top-big-text-gradient' />
                </div>
                <div className='container'>
                    <h2 className='big-text'>
                        San Diego: Your all-in-one life management solution.
                        <br />
                        <br />
                        Seamlessly organize time, expenses, and tasks
                        <br />
                        <br />
                        Effortless living made possible with the power of San Diego.
                    </h2>
                </div>
                <div className='big-text-white-gradient-holder'>
                    <div className='big-text-white-gradient' />
                </div>
            </div>

            <div id='FeatureList' className='section'>
                <div className='container'>
                    <div className='w-layout-grid feature-grid'>
                        <div id='w-node-_7b19d13e-0e8d-2369-5abf-e24fedfaa268-6c33c78d' className='card-item white-text'>
                            <div className='card-background' />
                            <div className='card-item-content'>
                                <img
                                    className='feature-1-image fade-in-on-scroll'
                                    src='/images/clock-dynamic-clay.webp'
                                    alt='Clock illustration'
                                    sizes='(max-width: 479px) 49vw, (max-width: 767px) 52vw, 703px'
                                    loading='lazy'
                                    srcSet='/images/clock-dynamic-clay-p-500.png 500w, /images/clock-dynamic-clay-p-800.png 800w, /images/clock-dynamic-clay.webp 1026w'
                                />
                                <div className='fade-in-on-scroll'>
                                    <h2 className='card-title'>Effortless Time Mastery</h2>
                                </div>
                                <div className='fade-in-on-scroll'>
                                    <p>In the fast-paced world we live in, San Diego empowers you to take control of your time like never before.</p>
                                </div>
                            </div>
                        </div>
                        <div id='w-node-_628315c7-9285-9cb1-4712-9cee2615c32b-6c33c78d' className='card-item'>
                            <div className='card-background' />
                            <div className='card-item-content'>
                                <div className='fade-in-on-scroll'>
                                    <h2 className='card-title'>Secure Information Hub</h2>
                                </div>
                                <div className='fade-in-on-scroll'>
                                    <p>From important documents and passwords to confidential notes and contacts, San Diego safeguards your sensitive data with state-of-the-art encryption.</p>
                                </div>
                            </div>
                            <img
                                className='card-person-image fade-in-on-scroll'
                                src='/images/SD-Person.webp'
                                alt='San Diego user'
                                sizes='(max-width: 479px) 92vw, 1244px'
                                loading='lazy'
                                srcSet='/images/SD-Person-p-500.png 500w, /images/SD-Person-p-800.png 800w, /images/SD-Person-p-1080.png 1080w, /images/SD-Person.webp 1114w'
                            />
                        </div>
                        <div id='w-node-_107edcd6-e1b1-ee1d-d87c-382208bdc80a-6c33c78d' className='card-item white-text'>
                            <div className='card-background main-gradient' />
                            <div className='card-text-with-iphone-content'>
                                <div className='card-item-content'>
                                    <div className='fade-in-on-scroll'>
                                        <div className='card-small-icon'>
                                            <img src='/images/ScaleIcon.svg' loading='lazy' alt='' className='card-small-icon-image' />
                                        </div>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <h2 className='card-title-xl'>Intelligent Finance Tracking</h2>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <p>Easily integrate with all your favorite tools through APIs including automatic integrations.</p>
                                    </div>
                                </div>
                                <div className='card-iphone on-card'>
                                    <div className='card-iphone-holder'>
                                        <div className='card-phone-image-container'>
                                            <img src='/images/SD-App.svg' loading='lazy' alt='' className='card-iphone-screelock' data-parallax data-parallax-scale='1.15,1' />
                                            <img
                                                src='/images/App2.webp'
                                                loading='lazy'
                                                sizes='(max-width: 479px) 73vw, 473px'
                                                srcSet='/images/App2-p-500.jpg 500w, /images/App2-p-800.jpg 800w, /images/App2.webp 1020w'
                                                alt=''
                                                className='width-full'
                                            />
                                        </div>
                                        <img
                                            src='/images/iPhoneMockup.webp'
                                            loading='lazy'
                                            sizes='(max-width: 479px) 92vw, 603px'
                                            srcSet='/images/iPhoneMockup-p-500.png 500w, /images/iPhoneMockup-p-800.png 800w, /images/iPhoneMockup-p-1080.png 1080w, /images/iPhoneMockup.webp 1419w'
                                            alt='San Diego finance dashboard'
                                            className='card-iphone-image'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id='DarkMode' className='section'>
                <div className='container display-on-section-scroll'>
                    <div id='w-node-ece89d93-2df3-9c66-994e-a99360ef72ee-6c33c78d' className='content'>
                        <div className='fade-in-on-scroll'>
                            <h2 className='white-text'>
                                Seamless Functionality <br />
                                <span className='text-gradient'>in Any</span> environment.
                            </h2>
                        </div>
                        <div className='text-container'>
                            <div className='fade-in-on-scroll'>
                                <p className='white-text'>San Diego understands that everyone has different preferences and environments, which is why it offers a sleek and efficient Dark Mode.</p>
                            </div>
                        </div>
                    </div>
                    <div className='product-phone-image-container product-phone-image-on-dark-section'>
                        <div className='product-container on-dark-section'>
                            <div className='product-phone-image-holder'>
                                <img
                                    src='/images/Holding-iPhone.webp'
                                    loading='lazy'
                                    sizes='(max-width: 1279px) 100vw, 1313.5px'
                                    srcSet='/images/Holding-iPhone-p-500.png 500w, /images/Holding-iPhone-p-800.png 800w, /images/Holding-iPhone-p-1080.png 1080w, /images/Holding-iPhone-p-1600.png 1600w, /images/Holding-iPhone-p-2000.png 2000w, /images/Holding-iPhone.webp 2475w'
                                    alt='San Diego dark mode on iPhone'
                                    className='product-phone-image'
                                />
                                <div className='product-phone-content'>
                                    <img src='/images/SD-App.svg' loading='lazy' alt='' className='product-phone-demo-image _1' />
                                    <img
                                        src='/images/App2.webp'
                                        loading='lazy'
                                        sizes='(max-width: 479px) 100vw, 554px'
                                        srcSet='/images/App2-p-500.jpg 500w, /images/App2-p-800.jpg 800w, /images/App2.webp 1020w'
                                        alt=''
                                        className='product-phone-demo-image _2'
                                        data-parallax
                                        data-parallax-x='100,0'
                                    />
                                </div>
                                <div className='product-phone-image-overlay' />
                            </div>
                        </div>
                    </div>
                    <div className='cta-on-dark-section'>
                        <div className='fade-in-on-scroll'>
                            <div className='cta-on-dark-images-holder'>
                                <img
                                    src='/images/App2.webp'
                                    loading='lazy'
                                    sizes='(max-width: 479px) 37vw, 238px'
                                    srcSet='/images/App2-p-500.jpg 500w, /images/App2-p-800.jpg 800w, /images/App2.webp 1020w'
                                    alt=''
                                    className='cta-on-dark-app _1'
                                    data-parallax
                                    data-parallax-y='0,-30'
                                />
                                <img
                                    src='/images/SD-App.svg'
                                    loading='lazy'
                                    alt=''
                                    className='cta-on-dark-app _2'
                                    data-parallax
                                    data-parallax-y='0,30'
                                />
                            </div>
                        </div>
                        <div className='fade-in-on-scroll'>
                            <h2 className='cta-dark-title'>
                                Download <br />
                                San Diego Now!
                            </h2>
                            <p className='white-text'>
                                Discover how digital presenteeism damages productivity and
                                <br />
                                prevents asynchronous work
                            </p>
                            <SubscribeForm buttonText='Download Report' />
                            <div className='subscribe-bottom-text'>
                                By clicking Subscribe, you confirm to have read Our{' '}
                                <Link href={routes.privacy} className='inline-link-on-dark'>
                                    terms and services
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='section-dark-bg-scale' data-parallax data-parallax-scale='0.9,1' data-parallax-end='center center' />
            </div>

            <div id='pricing' className='section'>
                <div className='container'>
                    <div className='fade-in-on-scroll'>
                        <h2>
                            Flexible pricing for <span className='text-gradient'>companies</span> and developers
                        </h2>
                    </div>
                    <div className='fade-in-on-scroll'>
                        <div className='text-container'>
                            <p>Easily combine and sync all the media from a single shoot, then tap to choose your best footage.</p>
                        </div>
                    </div>
                    <div className='pricing-table'>
                        <div className='content'>
                            <div className='pricing-table-info'>
                                <div className='fade-in-on-scroll'>
                                    <h3 className='heading-3-style'>Keep everything organised</h3>
                                </div>
                                <div className='fade-in-on-scroll'>
                                    <div>Bring time, expenses, and tasks into one shared view, so your whole team always knows what is happening and what comes next.</div>
                                </div>
                                <div className='fade-in-on-scroll'>
                                    <div className='button-holder-left-justify-bottom'>
                                        <Link href={routes.pricing} className='button black-button-with-icon w-button'>
                                            See pricing
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='content'>
                            <div className='card-item pricing-card'>
                                <div className='card-item-content pricing-item-content'>
                                    <div className='pricing-item-content'>
                                        <div className='pricing-title'>Core</div>
                                        <div className='pricing-main-content'>
                                            <div className='product-item-price'>
                                                <sup className='superscript'>$</sup>20
                                            </div>
                                            <div className='pricing-item-price-desc'>
                                                per user / month
                                                <br />
                                                billed annually
                                            </div>
                                        </div>
                                        <div className='pricing-item-description'>For teams that want a world-class experience for every member, without all the admin.</div>
                                    </div>
                                    <div className='pricing-item-button-holder'>
                                        <Link href={routes.pricing} className='button w-button'>
                                            Try for Free
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='content'>
                            <div className='card-item pricing-card'>
                                <div className='card-item-content pricing-item-content'>
                                    <div className='pricing-item-content'>
                                        <div className='pricing-title'>Pro</div>
                                        <div className='pricing-main-content'>
                                            <div className='product-item-price'>
                                                <sup className='superscript'>$</sup>50
                                            </div>
                                            <div className='pricing-item-price-desc'>
                                                per user / month
                                                <br />
                                                billed annually
                                            </div>
                                        </div>
                                        <div className='pricing-item-description'>For growing teams that need advanced controls, integrations, and priority support.</div>
                                    </div>
                                    <div className='pricing-item-button-holder'>
                                        <Link href={routes.pricing} className='button w-button'>
                                            Try for Free
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default HomePage
